import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class TagsService {
  fetchAllTags = (params) => {
    return fetch(config.config.endpointUrls.fetchAllTags(params), {
      method: 'GET'
    })
  }
}

export default new TagsService()



// WEBPACK FOOTER //
// ../src/services/tagsService/tagsService.js